//sizith cart

var numbVisiteur = Math.floor((Math.random() * 7) + 2);
var elemt = document.getElementById("ClientNombre");
var elemt2 = document.getElementById("changeSingulier");
elemt.innerHTML = numbVisiteur;

var singulier = "autre client est en train de passer commande. Vos objets sont réservés pour les 3 prochaines minutes.";
var pluriel = "autres clients sont en train de passer commande. Vos objets sont réservés pour les 3 prochaines minutes."

	if (numbVisiteur == 1) {

	elemt2.innerHTML = singulier;

	}

	else {

	elemt2.innerHTML = pluriel;

	}


setInterval(changeR, 8000);


function changeR() {


	if (numbVisiteur <= 2) {


	numbVisiteur = Math.floor((Math.random() * 7) + 2);
	elemt.innerHTML = numbVisiteur;


	if (numbVisiteur > 1) {
	elemt2.innerHTML = pluriel;		
	}


	else {

	elemt2.innerHTML = singulier;

	}


}

else if (numbVisiteur >= 7) {


numbVisiteur = Math.floor((Math.random() * 7) + 2);
elemt.innerHTML = numbVisiteur; 

if (numbVisiteur > 1) {

elemt2.innerHTML = pluriel;	

}

else {

elemt2.innerHTML = singulier;

}


}

else {

numbVisiteur = numbVisiteur + Math.floor((Math.random() * (3-2)) - 2);
elemt.innerHTML = numbVisiteur; 	  

if (numbVisiteur > 1) {
elemt2.innerHTML = pluriel;		
}

else {
elemt2.innerHTML = singulier;
}

}

};  